var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.data),function(el,i){return _c('div',{key:i},[_vm._v(_vm._s(el.name)+": "+_vm._s(el.value))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }